import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { AlertService, CampaignService, CancelReasonCategoryService, FunnelStepService } from '../../_services';
import { CrudSavePopupComponent } from '../../_directives';
import { FormBuilder, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import {Campaign, OfferTypes, Pager, StepPopupActions } from '../../_models';
import { TroubleshooterOfferIntents } from '../step-util';

@Component({
  moduleId: module.id.toString(),
  selector: 'template-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./../steps.component.scss'],
})
export class TemplatePopupComponent extends CrudSavePopupComponent implements OnInit {
  ngModelOptions = { standalone: true };
  operation: Observable<Object>;
  StepPopupActions = StepPopupActions;
  title = 'template';
  useExistingTemplate: boolean = true;
  campaigns: Campaign[] = [];

  constructor(
    protected router: Router,
    protected location: Location,
    protected route: ActivatedRoute,
    protected formBuilder: FormBuilder,
    protected funnelStepService: FunnelStepService,
    protected cancelReasonCategoriesService: CancelReasonCategoryService,
    protected alertService: AlertService,
    protected campaignService: CampaignService
  ) {
    super(router, location, route, funnelStepService, alertService);
    this.objectName = 'Offer';
    this.isNew = false;
    this.isPartial = true;
  }

  ngOnInit() {
    this.setForm(
      this.formBuilder.group({
        name: [this.inputData.name || '', Validators.required],
        category: this.inputData.category,
        is_global: false,
        offer_intent: [null],
        campaign: [null]
      })
    );
    super.ngOnInit();

    this.campaignService.list({is_hybrid: false})
      .subscribe((data: Pager) => {
        if (data) {
          let currentCampaignId = this.campaignService.getCurrentCampaignId()
          this.campaigns = data.results.filter((campaign: Campaign) => campaign.id !== currentCampaignId)
        }
      }, error => {
        this.handleError(error)
      })
  }

  onSubmit() {
    this.submitted = true;
    const data = {use_existing_template: this.useExistingTemplate}

    if (this.inputData.popupType === StepPopupActions.CloneOffer) {
      data['campaign'] = this.form.value['campaign']
    }
    this.onSave.emit(data);
  }

  performOperation(operationTitle) {
    this.operation.subscribe(
      (data) => {
        if (this.showSuccessMessage) {
          this.alertService.success(`${operationTitle} Successfully.`, true);
        }

        this.canDeactivateService.setFormDirty(false);
        this.onSaveComplete(data);
      },
      (error) => {
        this.handleSubmitError(error);
        this.loading = false;
      }
    );
  }

  isCustomerPortal(offerType: OfferTypes) {
    return offerType === OfferTypes.CustomerPortal;
  }

  protected getFormData() {
    const data = {
      ...this.form.value,
      popupType: this.inputData.popupType,
      offer_id: +this.inputData.offer_id,
      offer_type: this.inputData.offer_type,
      offer_intent: this.inputData.offer_intent,
      is_survey: this.inputData.is_survey,
    };
    return data;
  }

  get isTroubleshooterApplicable(): boolean {
    let applicable = false;
    if (this.inputData && this.inputData.offer_intent) {
      applicable = TroubleshooterOfferIntents.indexOf(this.inputData.offer_intent) !== -1;
    }
    return applicable;
  }

  popupTypeTextMap: Partial<Record<StepPopupActions, string>> = {
    [StepPopupActions.CreateTemplate]: 'Next',
    [StepPopupActions.CloneOffer]: 'Clone',
  };
}
